'use strict';

var _setup = require('./setup.js');

//list of all sites for the language select dropdown
// - name - used as text in dropdown
// - abbr - used for unique classname (flags are bg's in css)
// - host - the site's hostname to match & determine current site
var nxmlSites = [{ name: 'USA', abbr: 'US', host: 'nexgrill.com' }, { name: 'Canada', abbr: 'CA', host: 'nexgrill.ca' }, { name: 'Denmark', abbr: 'DK', host: 'nexgrill.dk' }, { name: 'United Kingdom', abbr: 'UK', host: 'nexgrill.co.uk' }];

//templating
var getListItems = function getListItems(activeIndex) {
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  nxmlSites.forEach(function (site, i) {
    var liClass = activeIndex === i ? 'is-active' : '';
    list += '<li class="' + liClass + '"><a href="http://' + site.host + '">\n              <span class="nx-langdrop--flag flag--' + site.abbr.toLowerCase() + '"><span></span></span>\n              <span class="nx-langdrop--name">' + site.abbr + '</span>\n            </a></li>';
  });
  return list;
},
    dropTemplate = function dropTemplate(extraclasses) {
  var defaultSiteIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var iconDir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'down';
  return '<div class="nx-langdrop ' + extraclasses + '">\n    <button class="nx-langdrop--btn">\n      <span class="nx-langdrop--btnitems">\n        <span class="nx-langdrop--flag flag--' + nxmlSites[defaultSiteIndex].abbr.toLowerCase() + '"><span></span></span>\n        <span class="nx-langdrop--text">\n          <span class="nx-langdrop--current">' + nxmlSites[defaultSiteIndex].abbr + '</span>\n          <i class="icon-' + iconDir + '-dir" aria-hidden="true"></i>\n        </span>\n      </span>\n    </button>\n    <div class="nx-langdrop--list">\n      <div class="nx-langdrop--liner">\n        <ul>' + getListItems(defaultSiteIndex) + '</ul>\n      </div>\n    </div>\n  </div>';
};

//button dropdown (toggle css class)
var bindButtonHandler = function bindButtonHandler(i, item) {
  var $this = $(item),
      $parent = $this.parent('.nx-langdrop'),
      isHeader = $parent.hasClass('nx-header--langdrop');
  $this.on('click', function (e) {
    e.preventDefault();
    if ($parent.hasClass('is-open')) {
      $parent.removeClass('is-open');
      if (isHeader) {
        _setup._s.langDropShowing.header = false;
      } else {
        _setup._s.langDropShowing.footer = false;
      }
    } else {
      $parent.addClass('is-open');
    }
    e.stopPropagation();
  });
};

//where are we?
// for future (will need to change first line of langInit)
var getCurrentLangIndex = function getCurrentLangIndex() {
  if (window.hostname === 'localhost') return 0;
  for (var i = 0; i < nxmlSites.length; i++) {
    if (nxmlSites[i].host.indexOf(window.location.hostname) > -1) {
      return i;
    }
  }
};

//close all open dropdowns on outside click
var clearOnClickout = function clearOnClickout() {
  var $opens = $('.nx-langdrop.is-open');
  if ($opens.length) {
    $opens.removeClass('is-open');
    _setup._s.langDropShowing.header = false;
    _setup._s.langDropShowing.footer = false;
  }
};

var langInit = function langInit() {
  var defaultIndex = getCurrentLangIndex();

  //add dropdowns to header/footer
  $('.nx-header--auxlinks').prepend(dropTemplate('nx-header--langdrop', defaultIndex, 'down'));
  $('.nx-footer--copyright').after(dropTemplate('nx-footer--langdrop', defaultIndex, 'up'));

  //btn click handlers
  $('.nx-langdrop--btn').each(bindButtonHandler);
  //clickout behavior
  $(document).on('click', clearOnClickout);
};

//langInit();


//////////////////
// WEBPACK FOOTER
// ./_js/lang-menu-drop.js
// module id = 9
// module chunks = 0